import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteSessionPayload } from '@app-store/slices/sessions/deleteSession'

interface TaskAction extends Action {
    payload: IDeleteSessionPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.sessions.delete

function* deleteSessionSagaTask({ payload }) {
    try {
        const response = yield axios.delete(`/event/session/${payload.sessionId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Session deleted successfully.'
            })
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteSessionSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteSessionSagaTask)
}

export default deleteSessionSaga
